export default "__VITE_ASSET__565443b5__"